import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Box from "../../../components/Box";
import { storeActivityIndicator } from '../../../redux/reducers/authSlice';
import { DashboardService } from '../../../services/DashboardService';
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import toast from "react-hot-toast";
import BasicDashboardItem from '../Components/BasicDashboardItem';
import { GetMarketingDashboardResponse, GetMarketingDashboardResponseData } from '../../../models/response/dashboard/GetMarketingDashboardResponse';

const MarketingDashboard = () => {
    const [data, setData] = useState<(GetMarketingDashboardResponseData | undefined)[]>([]);
    const dispatch = useDispatch();

    useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        try {
            dispatch(storeActivityIndicator(true));

            var response: GetMarketingDashboardResponse = await DashboardService.getMarketingDashboard();

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            while (response.data.length % 4 != 0) {
                response.data.push(undefined);
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    return (
        <KTCard>
            <KTCardBody>
                <Box mb='2rem'>
                    <h2 className='m-0 p-0'>Pazarlama</h2>
                </Box>

                <Box mb='2rem'>
                    <h2 className='m-0 p-0'>Görüşme Şekilleri</h2>
                </Box>

                <Box flexDirection='row' gap='2.25rem'>
                    {
                        data.map((item, index) => (
                            <React.Fragment>
                                {
                                    item ? (
                                        <BasicDashboardItem label={item.key} value={item.value.toString()} />
                                    ) : (
                                        <Box flex={1 / 4}>&nbsp;</Box>
                                    )
                                }
                            </React.Fragment>

                        ))
                    }
                </Box>
            </KTCardBody>
        </KTCard>
    )
}

export default MarketingDashboard;